import { useContext, useCallback } from 'react'
import { AuthContext, CurrentCustomerContext, PageContext } from 'contexts'
import { useNavigate } from 'react-router-dom'
import { useCurrentAgency } from './useCurrentAgency'
import { useCustomers } from './useCustomers'
import { useSupportUsers } from './useSupportUsers'
import { usePageNotifications } from './usePageNotifications'

export const useAuth = () => {
  const navigate = useNavigate()
  const { dispatch: dispatchAgencyAction } = useCurrentAgency(null)
  const { dispatch: dispatchCustomersAction } = useCustomers()
  const { dispatch: dispatchSupportUsersAction } = useSupportUsers()
  const { dispatch: dispatchNotification } = usePageNotifications()
  const { dispatch: dispatchCustomerAction } = useContext(
    CurrentCustomerContext,
  )
  const { dispatch: dispatchPageAction } = useContext(PageContext)
  const { state, dispatch } = useContext(AuthContext)

  const performLogoutFlow = useCallback(() => {
    dispatch({
      type: 'Logout',
    })

    // now clear out the assist data
    dispatchAgencyAction({
      type: 'Clear',
    })

    dispatchCustomerAction({
      type: 'Clear',
    })

    dispatchCustomersAction({
      type: 'Clear',
    })

    dispatchNotification({
      type: 'ClearAll',
    })

    dispatchSupportUsersAction({
      type: 'Clear',
    })

    dispatchPageAction({
      type: 'ClearAllPersistedPageStateBags',
    })

    var federatedLogoutEndpoint = localStorage.getItem(
      'FieldOps::LogoutEndpoint',
    )
    if (federatedLogoutEndpoint !== null) {
      window.location.assign(federatedLogoutEndpoint)
    } else {
      // now send them to the sign-in screen
      navigate('/')
    }
  }, [
    dispatch,
    dispatchAgencyAction,
    dispatchCustomerAction,
    dispatchCustomersAction,
    dispatchNotification,
    dispatchSupportUsersAction,
  ])

  const isAuthenticated = state.user !== null

  return {
    isAuthenticated,
    user: state.user,
    lastApiCall: state.lastApiCall,
    loginSessionTimeoutInMinutes: state.loginSessionTimeoutInMinutes,
    dispatch,
    performLogoff: performLogoutFlow,
    sessionWarningSeconds: 60,
    authorizedAgencies: state.authorizedAgencies,
    agencies: state.agencies
  }
}
